import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLenis } from "lenis/react";
import { Aperture } from "lucide-react";

const LINKS = [
  { label: "Campaigns", href: "#creative-campaigns" },
  { label: "Work", href: "#work" },
  { label: "Big Sharks", href: "#big-sharks" },
  { label: "Social", href: "#social" },
  { label: "Case Studies", href: "#case-studies" },
  { label: "Contact", href: "#contact" },
];

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const lenis = useLenis();

  const go = (e, href) => {
    e.preventDefault();
    lenis?.scrollTo(href, { offset: -20 });
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="top-nav"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-40 transition-colors duration-500 ${
        scrolled
          ? "border-b border-white/10 bg-[#0a0a0b]/80 backdrop-blur-xl"
          : "border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 pb-4 pt-12 md:px-16 md:pt-14">
        <a
          href="#hero"
          data-testid="nav-logo"
          onClick={(e) => go(e, "#hero")}
          className="flex items-center gap-3"
        >
          <Aperture className="h-5 w-5 text-[#CBFF3A]" strokeWidth={1.5} />
          <span className="font-hud text-xs uppercase tracking-[0.3em] text-[#ECEAE3]">
            Biswajit Dey
          </span>
        </a>

        <nav className="hidden items-center gap-10 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-hud text-[11px] uppercase tracking-[0.2em] text-white/55 transition-colors duration-300 hover:text-[#CBFF3A]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          onClick={(e) => go(e, "#contact")}
          data-testid="nav-hire-btn"
          className="rounded-full bg-[#CBFF3A] px-6 py-2.5 font-hud text-[11px] uppercase tracking-[0.15em] text-black transition-transform duration-300 hover:scale-105"
        >
          Hire Me
        </a>
      </div>
    </motion.header>
  );
}
